import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import BulletList from 'components/BulletList';
import SimpleModal from 'components/SimpleModal';
import Stack from 'components/Stack';
import Text from 'components/Text';
export function SaveChangedContentModal(_ref) {
  var onConfirm = _ref.onConfirm,
    onClose = _ref.onClose,
    onDiscard = _ref.onDiscard,
    contentPendingDeletion = _ref.contentPendingDeletion,
    isLoading = _ref.isLoading;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    title: t('actions_save_content_changes'),
    body: /*#__PURE__*/React.createElement(Stack, {
      spacing: "m"
    }, /*#__PURE__*/React.createElement(Text, {
      as: "p"
    }, t('modal_save_removed_changed_content_warning')), /*#__PURE__*/React.createElement(BulletList, null, contentPendingDeletion.map(function (item) {
      return item.name;
    })), /*#__PURE__*/React.createElement(Text, {
      as: "p"
    }, t('modal_save_removed_changed_content_confirmation'))),
    buttons: [{
      label: t('actions_save_changes'),
      onClick: onConfirm,
      isLoading: isLoading
    }, {
      label: t('actions_discard_changes'),
      onClick: onDiscard
    }],
    onClose: onClose
  });
}